/**
 * ScrollToTop Component
 * 
 * Automatically scrolls to top when route changes
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // Instant scroll to top (no smooth animation)
    window.scrollTo(0, 0);
    
    // Also set scrollRestoration to manual to prevent browser from restoring scroll
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
  }, [location.pathname]);

  return null;
};
